<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-6">
      <v-form class="py-3">
        <v-container>
          <div>
            <div><span class="span_style">General information</span></div>
            <v-text-field
              v-model="rowData.Title"
              single-line
              label="Title"
              :error-messages="
                $v.rowData.Title.$error ? 'Title is required' : null
              "
            ></v-text-field>
            <v-text-field
              v-model="rowData.Author"
              single-line
              label="Author"
              :error-messages="
                $v.rowData.Author.$error ? 'Auther is required' : null
              "
            ></v-text-field>
            <!-- <v-select single-line :items="show" label="Visibility"></v-select> -->
            <v-select
              :error-messages="
                $v.rowData.GroupId.$error ? 'Group is required' : null
              "
              v-model="rowData.GroupId"
              clearable
              single-line
              attach
              item-value="Id"
              item-text="Name"
              :items="GetDownloadFileGroups"
              label="Add to group"
            ></v-select>
            
            <v-select
                :error-messages="
                $v.rowData.Languages.$error
                  ? 'Select atleast one language'
                  : null
                "
                outlined
                class="my-5"
                dense
                :items="languageArray"
                v-model="rowData.Languages"
                :menu-props="{ maxHeight: '400' }"
                hide-details
                label="Language"
                multiple
                persistent-hint
              ></v-select>
            <v-text-field
              type="number"
              :error-messages="
                $v.rowData.DisplayOrder.$error
                  ? 'Display Order is required'
                  : null
              "
              single-line
              v-model="rowData.DisplayOrder"
              label="Display Order"
            ></v-text-field>
          </div>

          <div><span class="span_style">File</span></div>
          <div v-if="showFileError" class="red--text">File is required</div>
          <v-row>
            <v-col md="5" sm="12">
              <v-btn
                class="text_style my-4 px-11"
                color="primary"
                outlined
                @click="onButtonClick"
                >Upload File</v-btn
              >
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.jpeg,.png,.zip,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                @change="onFileChanged"
              />
            </v-col>
            <v-col md="7" sm="12">
              <div class="d-flex align-center" style="height: 100%">
                <v-chip
                  color="primary"
                  @click:close="closechip()"
                  close
                  outlined
                  v-show="chip1 || UploadedfileName"
                  pill
                  ><span class="text_elispis">{{ this.UploadedfileName }}</span>
                </v-chip>
              </div></v-col
            >
          </v-row>
        </v-container>
      </v-form>
      <div class="d-flex gap-2 justify-end mx-5 py-5">
        <v-btn
          color="#A1A3A8"
          class="px-14 py-6 text_style"
          text
          @click="closeDialog(true)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          class="px-14 py-6 text_style"
          @click="handleFileUpload()"
          :disabled="disabledSave"
        >
          <span class="pa-4 text_style" v-if="btnloader !== true"> Save </span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    selectedRowData: {
      type: Object,
      default: () => ({}),
    },
    editDialog: {
      type: Boolean,
    },
  },
  name: "UploadFileComponent",
  mounted() {
    this.SubmittedBy = this.GetLoggedInUser.Id;
    this.rowData = { ...this.selectedRowData };
    if (this.rowData && this.rowData.Languages) {
      this.rowData.Languages = this.rowData.Languages.split(",");
    }
    if (this.rowData && this.rowData.File) {
      const index = this.rowData.File.indexOf("_");
      this.UploadedfileName = this.rowData.File.substring(index + 1);
    }
    // if (this.selectedRowData && this.selectedRowData.DisplayOrder) {
    //   this.rowData.DisplayOrder = parseInt(this.rowData.DisplayOrder, 10);
    // }
  },
  data() {
    return {
      SubmittedBy: null,
      showFileError: false,
      btnloader: false,
      disabledSave: false,
      selectedFile: null,
      chip1: false,
      isSelecting: false,
      UploadedfileName: "",
      rowData: {},
      show: ["Visibility", "Invisibility"],

      membershipArray: [
        "Student",
        "Access Member",
        "Life Sciences Member",
        "Standard Member",
        "Practicing Member",
        "Instructor",
      ],
      courseArray: [
        "BodyTalk Access",
        "BodyTalk Access Online",
        "(Mod 2) BodyTalk: Fundamentals - Part 2",
        "BodyTalk Fundamentals Online",
        "(Mod 3) BodyTalk: Principles of Consciousness",
        "(Mod 3) Principles of Consciousness Online",
        "(Mod 4(7)) BodyTalk: Bio-Dynamics",
        "(Mod 4(7)) BodyTalk: Bio-Dynamics Online",
        "(Mod 5) BodyTalk: Lymphatic Drainage & Applied A&P",
        "(Mod 6) BodyTalk: Macrocosmic BodyMind",
        "(Mod 6) BodyTalk: Macrocosmic BodyMind Online",
        "BodyTalk for Animals (Mod 8A)",
        "BodyTalk for Animals Online (Mod 8A)",
        "(Mod 9) BodyTalk: Matrix Dynamics",
        "(Mod 9) BodyTalk: Matrix Dynamics Online",
        "(BAI) BodyTalk: Advanced Integration",
        "(BAI) BodyTalk: Advanced Integration Online",
        "MindScape",
        "MindScape Online",
        "BreakThrough 1",
        "BreakThrough 1 Online",
        "FreeFall 1",
        "BodyTalk Access for Animals",
        "BodyTalk Access for Animals Online",
      ],
      PractitionerLevelArray: ["CBP", "AdvCBP", "CBP-A", "PaRama CBP	"],
      instructor: [],
      languageArray: [
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
        "English",
        "Swedish",
        "Danish"
      ],
      // DisplayOrderArray: [],
      exam: [],
    };
  },
  validations: {
    rowData: {
      Title: {
        required,
      },
      Author: {
        required,
      },
      GroupId: {
        required,
      },
      Languages: {
        required,
      },
      DisplayOrder: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters([
      "GetDownloadFileGroups",
      "GetLoggedInUser",
      "GetDownloadFiles",
    ]),
  },
  // created() {
  //   this.DisplayOrderArray = Array.from(
  //     { length: this.GetDownloadFiles.length || 1 },
  //     (_, index) => index + 1
  //   );
  // },

  methods: {
    closeDialog(cancel) {
      this.$emit("close-dialog", cancel);
      this.rowData = {};
      this.selectedFile = null;
    },
    handleFileUpload() {
      this.$v.rowData.$touch();
      !this.UploadedfileName
        ? (this.showFileError = true)
        : (this.showFileError = false);
      if (this.$v.rowData.$invalid || !this.UploadedfileName) {
        return;
      } else {
        this.disabledSave = true;
        this.btnloader = true;
        const formData = new FormData();
        formData.append("Title", this.rowData.Title);
        formData.append("Author", this.rowData.Author);
        formData.append("GroupId", this.rowData.GroupId);
        formData.append("Languages", this.rowData.Languages);
        formData.append("DisplayOrder", this.rowData.DisplayOrder);
        if (this.selectedFile) {
          formData.append("File", this.selectedFile);
        }
        formData.append("SubmittedBy", this.SubmittedBy);

        if (this.editDialog) {
          formData.append("Id", this.rowData.Id);
        }
        this.$store
          .dispatch(
            `${this.editDialog ? "UpdateDownloadFile" : "CreateDownloadFile"}`,
            formData
          )
          .then((res) => {
            this.disabledSave = false;
            this.btnloader = false;
            if (res.Status) {
              this.closeDialog();
            }
          })
          .catch((err) => {
            console.log(err);
            this.disabledSave = false;
            this.btnloader = false;
          });
      }
    },
    closechip() {
      this.selectedFile = null;
      this.chip1 = false;
      this.showFileError = true;
      this.UploadedfileName = "";
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.chip1 = true;
      this.selectedFile = e.target.files[0];
      this.UploadedfileName = this.selectedFile.name;
      this.showFileError = false;
      this.$refs.uploader.value = null;
      //
      // do something
    },

  },
};
</script>

<style scoped>
.text_elispis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.span_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  color: rgba(34, 34, 34, 1);
}
.v-text-field {
  padding-top: 2px !important;
  margin-top: 4px;
}
</style>
